import { gql } from '@apollo/client';

export default gql`
  query getContracts($isRTL: Boolean) {
    getContracts(isRTL: $isRTL) {
      ok
      error
      data {
        _id
        branch
        autoNo
        docNo
        additionId
        desc
        address
        name
        nameAr
        start
        end
        locationLink
        status
        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
